import { ROUTER_NAMES } from '../constants';
import Nav from '../components/admin/Nav';
import Footer from '../components/admin/Footer';

export default [
  {
    path: 'users',
    name: ROUTER_NAMES.ADMIN_USERS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/Users')
    }
  },
  {
    path: 'users/:userId',
    name: ROUTER_NAMES.ADMIN_USERS_EDIT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/EditUser')
    }
  },
  {
    path: 'events',
    name: ROUTER_NAMES.ADMIN_EVENTS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/Events')
    }
  },
  {
    path: 'events/:eventId/groups',
    name: ROUTER_NAMES.ADMIN_EVENTS_GROUPS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/Groups')
    }
  },
  {
    path: 'events/:eventId/participants',
    name: ROUTER_NAMES.ADMIN_EVENTS_PARTICIPANTS,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/Participants')
    }
  },
  {
    path: 'events/:eventId/participants/:userId/edit',
    name: ROUTER_NAMES.ADMIN_EVENTS_PARTICIPANTS_EDIT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/EditParticipant')
    }
  },
  {
    path: 'events/:eventId/edit',
    name: ROUTER_NAMES.ADMIN_EVENTS_EDIT,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/EditEvent')
    },
  },
  {
    path: 'events/:eventId',
    name: ROUTER_NAMES.ADMIN_EVENTS_DETAIL,
    components: {
      nav: Nav,
      footer: Footer,
      default: () => import('../views/adminPortal/DetailEvent')
    }
  },
]
